export default __webpack_public_path__ + "static/media/maa-diversify-banner.17dea4b1.png";